import "./css/VendorDashboard.css";
import { Card, Grid, Box, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "../../../toolkit/ButtonV1";
import InfoCard from "../../../toolkit/InfoCard";
import QuestionnairesItem from "../../../toolkit/QuestionnairesItem";
import axios from "../../../utils/fvAxios";
import { useNavigate } from "react-router-dom";
import GetfVDateFormate from "../../../utils/Genaricfunctions";
import MarkUnreadChatAltIcon from "@mui/icons-material/MarkUnreadChatAlt";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { getOrgId } from "../../../utils/Token";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Pending from "../../../icons/VendorStatusIcons/Pending.svg";
import NoResponse from "../../../icons/VendorStatusIcons/No Response.svg";
import Exception from "../../../icons/VendorStatusIcons/Exception.svg";
import Probation from "../../../icons/VendorStatusIcons/Probation.svg";
import Incomplete from "../../../icons/VendorStatusIcons/Incomplete.svg";
import NA from "../../../icons/VendorStatusIcons/NA.svg";
import Banned from "../../../icons/VendorStatusIcons/Banned.svg";
import Expired from "../../../icons/VendorStatusIcons/Expired.svg";
import Prequalified from "../../../icons/VendorStatusIcons/Prequalified.svg";
import NotPrequalified from "../../../icons/VendorStatusIcons/Not Prequalified.svg";
import Multiple from "../../../icons/VendorStatusIcons/Multiple.svg";
import PendingRenewal from "../../../icons/VendorStatusIcons/Pending-Renewal.svg";
import Processing from "../../../icons/VendorStatusIcons/Processing.svg";
import Graduation from "../../../icons/VendorStatusIcons/graduation.svg";
import ClientReview from "../../../icons/VendorStatusIcons/Client Review.svg";
import WidgetDrawer from "../../../components/Widget/WidgetDrawer";
import RecentNotification from "../../../icons/RecentNotification";
import { setviewallWidgit } from "../../../utils/Token";

function VendorDashboard() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [prequalificationStatusDesc, setPrequalificationStatusDesc] = useState(
    []
  );
  const [unreadMessageCount, setUnreadMessageCount] = useState(0);
  const [unreadNotificationCount, setUnreadNotificationCount] = useState(0);
  const [questionnaire, setQuestionnaire] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isMessageCountLoading, setIsMessageCountLoading] = useState(true);

  const venid = getOrgId();

  useEffect(() => {
    axios
      .get("/Prequalification/GetprequalificationStatuses")
      .then((res) => {
        if (res.data.responseCode === 100) {
          setPrequalificationStatusDesc(
            res?.data?.data?.filter((r) => r.showInDashBoard)
          );
        } else {
          setError(res.data.responseMessage);
        }
      })
      .catch((err) => {
        console.log(err);
      }).finally(() => {
        setIsLoading(false);
      })

    // axios
    //   .get("/Vendor/VendorDashboardPartialView?vendorId=" + venid)
    //   .then((res) => {
    //     if (res.data.responseCode === 100) {
    //       setQuestionnaire(res?.data?.data?.prequalifications);
    //       setUnreadMessageCount(res?.data?.data?.unreadMessagesCount);
    //       setUnreadNotificationCount(res?.data?.data?.unreadNotificationsCount);
    //     } else {
    //       setError(res.data.responseMessage);
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   }).finally(() => {
    //     setIsLoading(false);
    //   })
  }, []);

  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [Intialload, SetIntialload] = useState(true);

  useEffect(() => {
    setIsMessageCountLoading(true);
    axios.get(`/Vendor/VendorDashboard?vendorId=${venid}&pageNumber=${pageNumber}&pageSize=7`)
      .then((res) => {
        if (res?.data?.responseCode === 100) {
          setUnreadNotificationCount(res?.data?.data?.unreadNotificationsCount)
          setUnreadMessageCount(res?.data?.data?.unreadMessagesCount)
        } else {
          setError(res?.data?.responseMessage);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsMessageCountLoading(false);
      });
  }, []);

  useEffect(() => {
    const loadQuestionnaires = () => {
      setIsLoading(true);
      axios
        .get(`/Vendor/VendorDashboardPartialView?vendorId=${venid}&pageNumber=${pageNumber}&pageSize=7`)
        .then((res) => {
          if (res?.data?.responseCode === 100) {

            if (pageNumber === 1) {
              setQuestionnaire(res.data.data.prequalifications);
            } else {

              setQuestionnaire((prevQuestionnaire) => [...prevQuestionnaire, ...res.data.data.prequalifications]);
            }
            setHasMore(res?.data?.data?.prequalifications.length === 7);
          } else {
            setError(res.data.responseMessage);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setIsLoading(false);
          SetIntialload(false);
        });
    };

    loadQuestionnaires();
  }, [pageNumber]);



  // const handleScroll = (e) => {
  //   console.log("Scroll Top:", e.target.scrollTop);
  //   console.log("Client Height:", e.target.clientHeight);
  //   console.log("Scroll Height:", e.target.scrollHeight);

  //   const bottom = e.target.scrollTop + e.target.clientHeight === e.target.scrollHeight;
  //   console.log("At Bottom:", bottom);

  //   if (bottom && hasMore) {
  //     setPageNumber((prevPageNumber) => prevPageNumber + 1);
  //   }
  // };
  const handleScroll = (e) => {

    const bottom = e.target.scrollTop + e.target.clientHeight + 1 >= e.target.scrollHeight;

    if (bottom && hasMore) {
      setPageNumber((prevPageNumber) => prevPageNumber + 1);
    }
  };



  useEffect(() => {
    const container = document.getElementById("#questionnaireContainer");
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleScroll]);

  const [widgedVisible, setWidgedVisiblity] = useState(false);


  const handleCommunicationClick = () => {
    setWidgedVisiblity(!widgedVisible)
    setviewallWidgit(!widgedVisible) // sesson management for widgit opening

  };

  const handleNotifcationClick = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    urlSearchParams.set('widgetHistoryTab', !widgedVisible);
    const newUrl = `${window.location.pathname}?${urlSearchParams.toString()}`;
    window.history.replaceState(null, '', newUrl);
    setWidgedVisiblity(!widgedVisible)
    setviewallWidgit(!widgedVisible) // sesson management for widgit opening
  };

  const initialPhaseStatuses = ["Pending", "Processing", "Pending-Renewal"];
  const intermediatePhaseStatuses = ["Client Review", "Incomplete", "N/A"];
  const finalPhaseStatuses = ["Incomplete", "Multiple", "No Response-FV Request", "No Response-Not Complete", "No Response-Expired Doc", "Probation", "Exception", "Exception-Missing Information", "Not Prequalified", "Prequalified", "Expired", "N/A", "Exception-Does Not Meet Requirement(s)", "BANNED", "Training Only"];
  const allPhaseStatuses = [...intermediatePhaseStatuses, ...finalPhaseStatuses];
  const renderStatusesByPhase = (phaseStatuses, allStatuses) => (
    <>
      <Grid container >
        {allStatuses
          ?.filter((stat) => phaseStatuses?.includes(stat?.prequalificationStatus))
          ?.sort((a, b) =>
            allPhaseStatuses?.indexOf(a.prequalificationStatus) - allPhaseStatuses?.indexOf(b.prequalificationStatus)
          )
          ?.map((stat) => (
            <Grid border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" item xs={12} sm={6} md={6} style={{ marginLeft: 0 }}>
              <div key={stat.prequalificationStatusId} style={{ padding: "10px" }}>
                <Stack direction="row" spacing={2} >
                  {stat?.prequalificationStatusId == 33 || stat?.prequalificationStatusId == 4 || stat?.prequalificationStatusId == 32 ?
                    <Card sx={{ backgroundColor: "#EE3F3F", padding: "6px", width: "fit-content", height: "fit-content" }}>
                      <img src={NoResponse} alt="NoResponse" />
                    </Card>
                    : stat?.prequalificationStatusId == 13 ?
                      <Card sx={{ backgroundColor: "#ED8A17", padding: "6px", width: "fit-content", height: "fit-content" }}>
                        <img src={Exception} alt="Exception" />
                      </Card>
                      : stat?.prequalificationStatusId == 26 ?
                        <Card sx={{ backgroundColor: "#ED8A17", padding: "6px", width: "fit-content", height: "fit-content" }}>
                          <img src={Probation} alt="Probation" />
                        </Card>
                        : stat.prequalificationStatusId == 7 ?
                          <Card sx={{ backgroundColor: "#EE3F3F", padding: "6px", width: "fit-content", height: "fit-content" }}>
                            <img src={Incomplete} alt="Incomplete" />
                          </Card>
                          : stat.prequalificationStatusId == 14 ?
                            <Card sx={{ backgroundColor: "#374251", padding: "7px", width: "fit-content", height: "fit-content" }}>
                              <img src={NA} alt="N/A" />
                            </Card>
                            : stat.prequalificationStatusId == 31 ?
                              <Card sx={{ backgroundColor: "#EE3F3F", padding: "6px", width: "fit-content", height: "fit-content" }}>
                                <img src={Banned} alt="Banned" />
                              </Card>
                              : stat.prequalificationStatusId == 10 ?
                                <Card sx={{ backgroundColor: "#E4E7EC", padding: "6px", width: "fit-content", height: "fit-content" }}>
                                  <img src={Expired} alt="Expired" />
                                </Card>
                                : stat.prequalificationStatusId == 8 ?
                                  <Card sx={{ backgroundColor: "#EE3F3F", padding: "6px", width: "fit-content", height: "fit-content" }}>
                                    <img src={NotPrequalified} alt="NotPrequalified" />
                                  </Card>
                                  : stat.prequalificationStatusId == 9 ?
                                    <Card sx={{ backgroundColor: "#12B76A", padding: "6px", width: "fit-content", height: "fit-content" }}>
                                      <img src={Prequalified} alt="Prequalified" />
                                    </Card>
                                    : stat.prequalificationStatusId == -1 ?
                                      <Card sx={{ backgroundColor: "#7B61FF", padding: "6px", width: "fit-content", height: "fit-content" }}>
                                        <img src={Multiple} alt="Multiple" />
                                      </Card>
                                      : stat.prequalificationStatusId == 5 ?
                                        <Card sx={{ backgroundColor: "#EE3F3F", padding: "6px", width: "fit-content", height: "fit-content" }}>
                                          <img src={Processing} alt="Processing" />
                                        </Card>
                                        : stat.prequalificationStatusId == 15 ?
                                          <Card sx={{ backgroundColor: "#EE3F3F", padding: "6px", width: "fit-content", height: "fit-content" }}>
                                            <img src={PendingRenewal} alt="PendingRenewal" />
                                          </Card>
                                          : stat.prequalificationStatusId == 16 ?
                                            <Card sx={{ backgroundColor: "#EE3F3F", padding: "6px", width: "fit-content", height: "fit-content" }}>
                                              <img src={ClientReview} alt="ClientReview" />
                                            </Card>
                                            : stat.prequalificationStatusId == 34 ?
                                              <Card sx={{ backgroundColor: "#ffef00", padding: "6px", width: "fit-content", height: "fit-content" }}>
                                                <img src={Graduation} alt="Training Only" />
                                              </Card>
                                              : <Card sx={{ backgroundColor: "#EE3F3F", padding: "6px", width: "fit-content", height: "fit-content" }}>
                                                <img src={Pending} alt="Pending" />
                                              </Card>

                  }
                  <div style={{ width: "300px" }}>
                    <span style={{ fontWeight: "bold" }}>
                      {stat.prequalificationStatus}
                    </span>
                    <p style={{ color: "#667085" }}>{stat.prequalificationDescription}</p>
                  </div>
                </Stack>
              </div>
            </Grid>
          ))}
      </Grid>
    </>
  );
  return (
    <div style={{ padding: "20px" }}>
      {widgedVisible && (
        <WidgetDrawer
          widgedVisible={widgedVisible}

          onChangeVisibility={(resp) => setWidgedVisiblity(resp)}
        />

      )}
      {/* <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop> */}
      {/* <span
        style={{
          fontSize: "28px",
          fontWeight: "bold",
        }}
      >
        {t("Dashboard.dashboard")}
      </span> */}

      {/* <Stack direction="row" alignItems="center" spacing={20}>
        <span
          style={{
            fontSize: "28px",
            fontWeight: "bold",
            flexShrink: 0,
          }}
        >
          {t("Dashboard.dashboard")}
        </span>
        <Card
          className="mt-1"
          sx={{
            backgroundColor: "#EE3F3F",
            padding: "8px 16px",
            width: "fit-content",
            height: "fit-content",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <p
            style={{
              color: "aliceblue",
              margin: 0,
              textAlign: "center",
            }}
          >
            Exclusive member benefit: 20% off UL Solutions safety training (English & Spanish).&nbsp;
            <a
              href="/MoodleAssignBulkTrainings"
            >
              Click here
            </a>
          </p>
        </Card>
      </Stack> */}
      <Stack direction="row" alignItems="end" spacing={1}>
        <span
          style={{
            fontSize: "28px",
            fontWeight: "bold",
            flexShrink: 0,
          }}
        >
          {t("Dashboard.dashboard")}
        </span>
        <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "center" }}>
          {/* <Card
            className="mt-1"
            sx={{
              backgroundColor: "#EE3F3F",
              padding: "8px 16px",
              width: "fit-content",
              height: "fit-content",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <p
              style={{
                color: "aliceblue",
                margin: 0,
                textAlign: "center",
              }}
            >
              Exclusive member benefit: 20% off UL Solutions safety training (English & Spanish). &nbsp;
              <a
                style={{
                  // textDecoration: "none",
                  // color: "white",
                  // fontWeight: "bold",
                }}
                href="/MoodleAssignBulkTrainings"
              >
                {" "}Click here
              </a>
            </p>
          </Card> */}
          <Card
            className="mt-1"
            sx={{
              backgroundColor: "#EE3F3F",
              padding: "8px 16px",
              width: "fit-content",
              height: "fit-content",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <p style={{ color: "aliceblue", marginBottom: '0rem' }}>
              Beginning January 1, 2026, a $195 account subscription fee will be added to support the ongoing<br />
              maintenance, security, and reliability of the <b>FIRST,</b> VERIFY platform.
              <ul style={{ marginBottom: '0rem' }}>
                <li>The fee will be collected with your first renewal or new prequalification fee in 2026.</li>
                <li>It counts toward your yearly fee cap.</li>
                <li>It will not be collected again until your next prequalification 12 months later.</li>
                <li>The fee is not associated with any individual hiring client.</li>
              </ul>
              Even with this fee, <b>FIRST,</b> VERIFY remains one of the most affordable prequalification options on <br />
              the market. Our hiring clients have already been notified.
            </p>
          </Card>
        </Box>
      </Stack>

      <Card className="options-container d-flex">
        <div className="option-item text-align-center col-4" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '10px' }}>
          <p>{t("VendorDashboard.clientCodeStart")}</p>

          <Button
            label="Enter Client Code"
            size="medium"
            onClick={(e) => {
              navigate("/ListOfPotentialClients?Vendor=" + venid + "&TypeIdx=1");
            }}
            style={{ marginTop: 'auto' }}
          />
        </div>
        <div className="option-item text-align-center col-4" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '10px' }}>
          <p>{t("VendorDashboard.clientManually")}</p>

          <Button
            label="Find clients manually"
            size="medium"
            onClick={(e) => {
              navigate("/ListOfPotentialClients?Vendor=" + venid + "&TypeIdx=0");
            }}
            style={{ marginTop: 'auto' }}
          />
        </div>
        <div className="option-item text-align-center col-4" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '10px' }}>
          <p>{t("VendorDashboard.renewPrequalification")}</p>
          <Button
            label="Renew Prequalification"
            size="medium"
            onClick={(e) => {
              navigate("/ListOfPotentialClients?Vendor=" + venid + "&TypeIdx=2");
            }}
            style={{ marginTop: 'auto' }}
          />
        </div>
      </Card>


      <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>

        <Grid item xs={12} sm={6} md={8} lg={8}>
          <div>
            <Grid container item xs={12} columnSpacing={2}>
              <Grid item xs={6}>
                {isMessageCountLoading ? (
                  <Box sx={{ display: "flex", padding: "10px" }}>
                    <CircularProgress />
                  </Box>
                ) : (
                  <InfoCard
                    icon={<MarkUnreadChatAltIcon />}
                    title={t("VendorDashboard.unread")}
                    description={unreadMessageCount}
                    link={handleCommunicationClick}
                  />
                )}
              </Grid>
              <Grid item xs={6}>
                {isMessageCountLoading ? (
                  <Box sx={{ display: "flex", padding: "10px" }}>
                    <CircularProgress />
                  </Box>
                ) : (
                  <InfoCard
                    icon={<RecentNotification />}
                    title={t("VendorDashboard.recent")}
                    description={unreadNotificationCount}
                    link={handleNotifcationClick}
                  />
                )}
              </Grid>
            </Grid>
          </div>
          <div className="mt-2">
            <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" style={{ backgroundColor: "#fff" }}>
              <p className="mx-3 mt-3" style={{ fontWeight: "bold", fontSize: "20px", backgroundColor: "#fff", color: "#3E4A62" }}>
                {t("VendorDashboard.statusDescription")}
              </p>
            </Box>
            <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" sx={{ backgroundColor: "#fff" }} hidden={prequalificationStatusDesc.length == 0}>
              <div>

                <div style={{ backgroundColor: "#E4E7EC", padding: "5px", color: "#3E4A62", marginTop: "10px", fontWeight: "500" }}> <span style={{ marginLeft: "15px" }}>INITIAL PHASE</span></div>
                <div >
                  {renderStatusesByPhase(initialPhaseStatuses, prequalificationStatusDesc)}
                </div>

                <div style={{ backgroundColor: "#E4E7EC", padding: "5px", color: "#3E4A62", fontWeight: "500" }}>  <span style={{ marginLeft: "15px" }}>INTERMEDIATE PHASE</span></div>
                <div >
                  {renderStatusesByPhase(intermediatePhaseStatuses, prequalificationStatusDesc)}
                </div>

                <div style={{ backgroundColor: "#E4E7EC", padding: "5px", color: "#3E4A62", fontWeight: "500" }}><span style={{ marginLeft: "15px" }}>FINAL PHASE</span></div>
                <div >
                  {/* {prequalificationStatusDesc.map((stat) => (
                      <div className="col-6" key={stat.prequalificationStatusId}>
                        <span style={{ fontWeight: "bold" }}>
                          {stat.prequalificationStatus}
                        </span>
                        <p style={{ color: "#667085" }}>{stat.prequalificationDescription}</p>
                      </div>
                    ))} */}
                  {renderStatusesByPhase(finalPhaseStatuses, prequalificationStatusDesc)}
                </div>
              </div>
            </Box>
          </div>
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={4} >
          <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" style={{ backgroundColor: "#fff" }}>
            <p className="mx-4 mt-3" style={{ fontWeight: "bold", fontSize: "20px" }}>
              {t("VendorDashboard.questionnaires")}
            </p>
          </Box>
          <Box borderLeft={1} borderRight={1} borderBottom={1} borderColor="#e4e7ec" style={{ height: "1384px", overflowY: "auto", backgroundColor: "#fff" }} id="#questionnaireContainer">
            <Box >

              <div className="questionnaire-container " >

                {questionnaire && questionnaire?.length !== 0 ? (
                  questionnaire?.map((val) => (
                    <div key={val.id} className="questionnaire-item ">
                      <QuestionnairesItem
                        PreQualificationID={val.prequalificationId}
                        id={val.prequalificationStatusId}
                        title={val.clientName}
                        logo={val.clientLogoPath}
                        statusId={val.prequalificationStatusId}
                        Label={val.linkText}
                        isMultiple={val.isMultiClient}
                        data={val}
                        submitted={
                          val.prequalificationSubmit === "" ||
                            val.prequalificationSubmit === null
                            ? "Yet to Submit"
                            : GetfVDateFormate("", val.prequalificationSubmit)
                        }
                        statusPeriod={`${GetfVDateFormate(
                          val.prequalificationStart
                        )} ${t("Dashboard.to")} ${GetfVDateFormate(
                          val.prequalificationFinish
                        )}`}
                      />
                    </div>
                  ))
                ) : (
                  <div className="empty-questionnaire" hidden={Intialload}>
                    <img src="/img/Document.png" alt="" />
                    <h5>No questionnaires selected</h5>
                    <p>
                      Do you want to <a href={"/ListOfPotentialClients?Vendor=" + venid + "&TypeIdx=0"} >start questionnaire</a>?
                    </p>
                  </div>
                )}
              </div>
              {isLoading && <p  >
                <div className="skeleton-loading">
                  <div className="skeleton-circle"></div>
                  <div className="skeleton-line"></div>
                  <div className="skeleton-line"></div>
                  <div className="skeleton-line"></div>

                </div>

              </p>}

              {/* {!isLoading && !hasMore && <p>No more items to load.</p>} */}
            </Box>
          </Box>
        </Grid>

      </Grid>
    </div>
  );
}

export default VendorDashboard;